<template>
  <v-dialog v-model="dialog" max-width="440" :fullscreen="$vuetify.breakpoint.smAndDown">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        depressed
        class="rounded-lg"
        color="error"
        dark
        v-bind="attrs"
        v-on="on"
      >
        Eliminar
      </v-btn>
    </template>

    <v-card class="del rounded-lg">
      <!-- header -->
      <div class="del__head">
        <div class="del__head-text">
          <h2 class="del__title">Eliminar miembro</h2>
          <p class="del__sub">Esta acción es permanente.</p>
        </div>
        <button
          type="button"
          class="del__close"
          @click="dialog = false"
          aria-label="Cerrar"
        >
          <hero-icon :icon="XMarkIcon" :size="18" />
        </button>
      </div>

      <div class="del__divider"></div>

      <!-- body -->
      <div class="del__body">
        <div class="del__chip">
          <hero-icon :icon="TrashIcon" :size="20" />
        </div>
        <p class="del__copy">
          ¿Seguro que querés eliminar este miembro? Esta acción
          <span class="error--text font-weight-medium">no se puede deshacer</span>.
        </p>
      </div>

      <!-- footer -->
      <div class="del__actions">
        <v-btn text color="primary" class="rounded-lg" @click="dialog = false">
          Cancelar
        </v-btn>
        <v-btn color="error" depressed class="rounded-lg" @click="save">
          Eliminar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { DeleteStaff } from "@/graphql/mutations/staff";
import HeroIcon from "@/components/shared/HeroIcon";
import XMarkIcon from "heroicons/24/outline/x-mark.svg";
import TrashIcon from "heroicons/24/outline/trash.svg";

export default {
  components: { HeroIcon },

  data() {
    return {
      XMarkIcon,
      TrashIcon,
      dialog: false
    };
  },

  props: {
    id: {
      type: String | Number,
      required: true
    }
  },

  methods: {
    save() {
      this.$apollo
        .mutate({
          mutation: DeleteStaff,
          variables: {
            input: {
              id: this.id
            }
          }
        })
        .then(res => {
          this.$emit("deleted");
          this.dialog = false;
        });
    }
  }
};
</script>

<style scoped>
.del {
  background: #fff;
  border: 1px solid #ece7de;
}

/* header */
.del__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 16px;
}
.del__title {
  font-size: 19px;
  font-weight: 700;
  color: #1a1814;
  margin: 0;
  line-height: 1.2;
}
.del__sub {
  font-size: 13px;
  color: #756f64;
  margin: 5px 0 0;
}
.del__close {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: #a39a8c;
  transition: background 0.15s ease, color 0.15s ease;
}
.del__close:hover {
  background: #f1ece3;
  color: #1a1814;
}

.del__divider {
  height: 1px;
  background: #ece7de;
}

/* body */
.del__body {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 22px 24px 18px;
}
.del__chip {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(192, 57, 43, 0.1);
  color: #c0392b;
}
.del__copy {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #1a1814;
  align-self: center;
}

/* footer */
.del__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 4px 24px 22px;
}
</style>
